<template>
  <div>
    <!-- Botón Registrar Firma -->
    <v-btn
      v-if="!formData || (formData && formData.EstadoFormulario != '3')"
      color="#c62828"
      size="x-large"
      @click="dialog = true"
    >
      Registrar firma
    </v-btn>

    <!-- Dialog Model -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="text-white" style="background-color: #c62828">
          Firma del responsable
        </v-card-title>

        <v-card-text>
          <vue-signature-pad
            ref="signaturePad"
            :options="options"
            class="firma-canvas"
          />
        </v-card-text>

        <v-card-actions class="justify-between px-4 pb-4">
          <v-btn variant="outlined" @click="limpiarFirma">Limpiar</v-btn>
          <div>
            <v-btn variant="tonal" @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary" @click="guardarFirma">Guardar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Firma capturada (opcional) -->
    <div v-if="firmaBase64 || modelValue" class="mt-4">
      <strong>Firma capturada:</strong>
      <v-img
        :src="firmaBase64 ? firmaBase64 : modelValue"
        max-width="150"
        max-height="80"
        class="mt-1 rounded"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { VueSignaturePad } from "vue-signature-pad";

const dialog = ref(false);
const signaturePad = ref(null);
const firmaBase64 = ref("");
const emit = defineEmits(["update:modelValue"]);

const options = {
  penColor: "black",
  backgroundColor: "white",
};

// ---- props & emits para v-model ----
const props = defineProps({
  formData: { type: Object, default: [] },
  modelValue: { type: String, default: "" }, // aquí llegará el base64 desde el padre si existe
});

function limpiarFirma() {
  signaturePad.value.clearSignature();
  emit("update:modelValue", ""); // limpiar también en el padre
}

function guardarFirma() {
  var respuestaBase64 = signaturePad.value.saveSignature();
  firmaBase64.value = respuestaBase64.data;
  dialog.value = false;
  console.log("Firma en base64:", firmaBase64.value);
  // si solo quieres el string base64 completo:
  emit("update:modelValue", firmaBase64.value);
}
</script>

<style scoped>
.firma-canvas {
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  height: 200px;
}
</style>
